var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.browse.Views.length > 0
    ? _c(
        "div",
        { staticClass: "browse" },
        [
          _c(
            "div",
            { staticClass: "title" },
            [
              _c("w-checkbox", {
                attrs: { value: _vm.isBrowseSelected },
                on: {
                  input: function ($event) {
                    return _vm.setBrowseChecked($event)
                  },
                },
              }),
              _c(
                "w-link",
                {
                  staticClass: "toggle-button",
                  on: {
                    click: function ($event) {
                      _vm.isOpen = !_vm.isOpen
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c("div", {
                        staticClass: "browse-icon",
                        class: _vm.getIconClass(_vm.browse),
                      }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.browse.Name.getTranslation(_vm.$i18n.locale)
                          ) +
                          " "
                      ),
                      _c("w-spacer"),
                      _c("w-fa", { attrs: { icon: _vm.angleDirection } }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c("w-transition-slide-height", [
            _vm.isOpen
              ? _c(
                  "div",
                  { staticClass: "toggle-content" },
                  _vm._l(_vm.browse.Views, function (view) {
                    return _c(
                      "div",
                      { key: view.ID },
                      [
                        _c("w-checkbox", {
                          attrs: {
                            value: _vm.isViewChecked(view),
                            label: view.Name,
                          },
                          on: {
                            input: function ($event) {
                              return _vm.setViewChecked(view, $event)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }